/**
 * CartListContainer
 * --
 */
import React from 'react';
import CartListPresenter from './CartListPresenter';

const CartListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <CartListPresenter />
    </>
  );
};

export default CartListContainer;
